/* LAUVEE - Refonte 2026 : comportements JS additionnels. */
(function () {
  'use strict';

  function normalize(value) {
    return String(value)
      .normalize('NFC')
      .replace(/[‎‏]/g, '')
      .trim()
      .toLowerCase();
  }

  /* Rafraichissement du tiroir apres un ajout.
     Quand le panier est vide au chargement de la page, le theme ne rend
     aucun contenu dans <cart-drawer> : renderContents() du theme plante
     alors sur .drawer__inner. Dans ce cas on injecte nous-memes le HTML
     des sections renvoyees par l'API, puis on ouvre le tiroir. */
  function renderCart(cart, response) {
    if (cart.querySelector('.drawer__inner')) {
      cart.renderContents(response);
      return;
    }

    var sections = response.sections || {};
    var parser = new DOMParser();
    var drawerHtml = sections['cart-drawer'];
    var source = drawerHtml
      ? parser.parseFromString(drawerHtml, 'text/html').querySelector('cart-drawer')
      : null;

    if (!source) {
      window.location.href = window.routes.cart_url;
      return;
    }

    cart.innerHTML = source.innerHTML;

    var bubbleHtml = sections['cart-icon-bubble'];
    var icon = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && icon) {
      var newCount = parser.parseFromString(bubbleHtml, 'text/html').querySelector('.cart-count-bubble');
      var oldCount = icon.querySelector('.cart-count-bubble');
      if (newCount && oldCount) oldCount.parentNode.replaceChild(newCount, oldCount);
      else if (newCount) icon.appendChild(newCount);
    }

    var overlay = cart.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof cart.close === 'function') {
      overlay.addEventListener('click', cart.close.bind(cart));
    }

    if (typeof cart.open === 'function') cart.open();
  }

  /* Ajout au panier en AJAX + rafraichissement du tiroir. */
  function addToCart(variantId, quantity, done) {
    var cart = document.querySelector('cart-drawer');
    if (!cart || typeof cart.renderContents !== 'function') {
      if (done) done(new Error('cart-drawer indisponible'));
      return;
    }

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity || 1);
    formData.append(
      'sections',
      cart
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        })
        .join(',')
    );
    formData.append('sections_url', window.location.pathname);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          if (done) done(new Error(response.description || response.message));
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'lauvee-refonte',
            productVariantId: variantId,
            cartData: response
          });
        }
        cart.classList.remove('is-empty');
        renderCart(cart, response);
        if (done) done(null, response);
      })
      .catch(function (error) {
        if (done) done(error);
      });
  }

  /* =========================================================
     1. Ajout au panier -> ouverture du tiroir (panier latéral)

     La section "featured-product" du thème embarque un script maison qui
     intercepte le clic sur "Ajouter au panier" et redirige vers /cart.
     On intercepte le clic en phase de CAPTURE (donc avant lui), on stoppe
     sa propagation, et on refait l'ajout nous-mêmes en ouvrant le tiroir.

     A SUPPRIMER le jour où la section produit sera refaite proprement.
     ========================================================= */
  function resolveVariantId(productInfo, sectionId) {
    var selected = [];
    productInfo.querySelectorAll('fieldset.product-form__input').forEach(function (fieldset) {
      var radio = fieldset.querySelector('input[type="radio"]:checked');
      if (radio) selected.push(normalize(radio.value));
    });

    var dataScript = document.getElementById('ProductVariantsData-' + sectionId);
    if (dataScript && selected.length) {
      try {
        var data = JSON.parse(dataScript.textContent);
        for (var i = 0; i < data.variants.length; i++) {
          var variant = data.variants[i];
          var matches = true;
          for (var j = 0; j < selected.length; j++) {
            if (normalize(variant.options[j]) !== selected[j]) {
              matches = false;
              break;
            }
          }
          if (matches) return variant.id;
        }
      } catch (e) {
        /* on retombe sur l'input caché */
      }
    }

    var input = productInfo.querySelector('[name="id"]');
    return input ? input.value : null;
  }

  function initCartDrawerOnAdd() {
    document.addEventListener(
      'click',
      function (event) {
        if (!event.target || !event.target.closest) return;

        var button = event.target.closest('.product-form__submit');
        if (!button || button.hasAttribute('disabled')) return;

        var productInfo = button.closest('product-info[data-section]');
        var cart = document.querySelector('cart-drawer');
        if (!productInfo || !cart || typeof cart.renderContents !== 'function') return;

        event.preventDefault();
        event.stopImmediatePropagation();

        var variantId = resolveVariantId(productInfo, productInfo.dataset.section);
        if (!variantId) return;

        var quantityInput = productInfo.querySelector('input[name="quantity"]');
        var quantity = quantityInput && quantityInput.value ? parseInt(quantityInput.value, 10) : 1;
        if (!quantity || quantity < 1) quantity = 1;

        var spinner = button.querySelector('.loading__spinner');
        button.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');

        addToCart(variantId, quantity, function (error) {
          if (error) console.error('Ajout au panier impossible :', error.message);
          button.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
      },
      true
    );
  }

  /* =========================================================
     2. Cross-sell : boutons "Ajouter [ + ]"
     ========================================================= */
  function initCartRecoAdd() {
    document.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest) return;
      var button = event.target.closest('[data-lv-reco-add]');
      if (!button || button.disabled) return;

      event.preventDefault();
      button.disabled = true;

      addToCart(button.dataset.variantId, 1, function (error) {
        if (error) {
          console.error('Ajout au panier impossible :', error.message);
          button.disabled = false;
        }
      });
    });
  }

  /* =========================================================
     3. Cross-sell du tiroir : defilement auto toutes les 3 s
        + glisser a la souris. Le contenu du tiroir est recree
        a chaque mise a jour du panier : on ne garde donc aucune
        reference, on relit la piste a chaque tour.
     ========================================================= */
  function initCartRecoCarousel() {
    var DELAY = 3000;
    var PAUSE = 6000;
    var lastTouch = 0;

    function currentTrack() {
      return document.querySelector('cart-drawer .lv-cart-reco__track');
    }

    /* Chromium ignore scrollTo({behavior:'smooth'}) tant que le scroll-snap
       obligatoire est actif : on le suspend pendant l'animation. */
    function suspendSnap(track) {
      track.style.scrollSnapType = 'none';
      clearTimeout(track.lvSnapTimer);
      track.lvSnapTimer = setTimeout(function () {
        track.style.scrollSnapType = '';
      }, 650);
    }

    ['pointerdown', 'touchstart', 'wheel'].forEach(function (type) {
      document.addEventListener(
        type,
        function (event) {
          if (!event.target || !event.target.closest) return;
          if (event.target.closest('.lv-cart-reco__track')) lastTouch = Date.now();
        },
        { capture: true, passive: true }
      );
    });

    setInterval(function () {
      var track = currentTrack();
      if (!track) return;
      if (Date.now() - lastTouch < PAUSE) return;

      var max = track.scrollWidth - track.clientWidth;
      if (max < 4) return;

      var card = track.querySelector('.lv-cart-reco__card');
      var step = card ? card.getBoundingClientRect().width + 10 : track.clientWidth;
      var next = track.scrollLeft + step;
      if (next > max - 4) next = 0;

      suspendSnap(track);
      track.scrollTo({ left: next, behavior: 'smooth' });
    }, DELAY);

    /* Glisser a la souris (le swipe tactile fonctionne deja nativement). */
    var dragTrack = null;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    document.addEventListener('mousedown', function (event) {
      if (!event.target || !event.target.closest) return;
      var track = event.target.closest('.lv-cart-reco__track');
      if (!track) return;

      dragTrack = track;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      moved = false;
      lastTouch = Date.now();
      suspendSnap(track);
    });

    document.addEventListener('mousemove', function (event) {
      if (!dragTrack) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 3) moved = true;
      if (!moved) return;

      event.preventDefault();
      dragTrack.scrollLeft = startScroll - delta;
      lastTouch = Date.now();
    });

    /* Un glissement ne doit pas declencher le lien de la carte. */
    document.addEventListener(
      'click',
      function (event) {
        if (moved && event.target.closest && event.target.closest('.lv-cart-reco__track')) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    function endDrag() {
      if (!dragTrack) return;
      dragTrack.style.scrollSnapType = '';
      dragTrack = null;
      setTimeout(function () {
        moved = false;
      }, 0);
    }

    document.addEventListener('mouseup', endDrag);
    document.addEventListener('mouseleave', endDrag);
  }

  /* =========================================================
     4. Barre "Ajouter au panier" collante
     ========================================================= */
  function initStickyAtc() {
    var bar = document.querySelector('[data-lv-sticky-atc]');
    if (!bar) return;

    var mainButton =
      document.querySelector('product-info .product-form__submit') ||
      document.querySelector('.product-form__submit');

    if (!mainButton) {
      bar.parentNode.removeChild(bar);
      return;
    }

    var stickyButton = bar.querySelector('[data-lv-sticky-add]');
    var stickyPrice = bar.querySelector('[data-lv-sticky-price]');
    var infoContainer = document.querySelector('.product__info-container') || document.body;
    var priceSource = infoContainer.querySelector('.price');

    stickyButton.addEventListener('click', function () {
      mainButton.click();
    });

    function syncButton() {
      stickyButton.disabled = mainButton.hasAttribute('disabled');
      var label = mainButton.querySelector('.lv-btn-label') || mainButton.querySelector('.button-text');
      var text = label ? label.textContent.trim() : '';
      if (text) stickyButton.textContent = text;
    }

    function syncPrice() {
      if (!priceSource || !stickyPrice) return;
      var amount =
        priceSource.querySelector('.price-item--sale') || priceSource.querySelector('.price-item--regular');
      if (amount && amount.textContent.trim()) {
        stickyPrice.textContent = amount.textContent.trim();
      }
    }

    new MutationObserver(function () {
      priceSource = infoContainer.querySelector('.price') || priceSource;
      syncButton();
      syncPrice();
    }).observe(infoContainer, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled']
    });

    syncButton();
    syncPrice();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      ).observe(mainButton);
    } else {
      bar.classList.add('is-visible');
    }
  }

  initCartDrawerOnAdd();
  initCartRecoAdd();
  initCartRecoCarousel();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();
